import Image from "components/Image"
import CallToAction from "components/CallToAction"
import getStoryblokLink from "utilities/getStoryblokLink"
import richText from "utilities/richText"

export default function ContentWithCheckeredBorder({ blok }) {
  return (
    <section id="important-details" className="checkerboard-pattern pb-64 xl:pb-0 relative">
      <div className="py-6 lg:pt-12 xl:pb-48 px-8 xl:px-12 xl:max-w-[960px] mx-auto xl:relative z-10 bg-white">
        {blok.featured_pet ? (
          <Image
            src={`/assets/pets/${blok.featured_pet}.png`}
            alt=""
            aria-hidden
            width={420}
            height={263}
            className="absolute z-20 px-6 right-1/2 translate-x-1/2 bottom-4 xl:-right-40 xl:translate-x-0"
            loader={undefined}
          />
        ) : null}
        <div className="prose-h2:text-l1 lg:prose-h2:text-xl1 prose-h2:text-center  prose-h2:pb-6 lg:prose-h2:pb-12 prose-h3:text-m1 prose-p:pb-6 prose-p:text-s2">
          {richText(blok.content)}
        </div>
        {blok.cta_label && blok.cta_link ? (
          <CallToAction href={getStoryblokLink(blok.cta_link)} style="secondary" className="table mx-auto my-6">
            {blok.cta_label}
          </CallToAction>
        ) : null}
      </div>
    </section>
  )
}
